<script>
	import TabGroup from "./components/TabGroup.svelte";
	import Modal from "./components/Modal.svelte";
	import Footer from "./components/Footer.svelte";

	import Editor from "./Editor.svelte";
	import Layout from "./Layout.svelte";
	import Background from "./Background.svelte";
	import Fonts from "./Fonts.svelte";
	import Render from "./Render.svelte";


	import { onMount } from "svelte";

	import { isSmall, activeTab, renderVis, renderedPost } from "./stores.js";

	let panels = [
		{
			label: "layout",
			id: 1,
			image: "layout",
			panel: Layout
		},
		{
			label: "fonts",
			id: 2,
			image: "typeface",
			panel: Fonts
		},
		{
			label: "background",
			id: 3,
			image: "swatches",
			panel: Background
		},
		{
			label: "render",
			id: 4,
			image: "create",
			panel: Render
		},
	];

	panels.forEach((p) => {
		p.img = `img/${p.image}.svg`;
	});

	//let layoutTypes = ["single", "double", "triple"];

	let aboutVis = false;

	const mqHandler = e => {
		if (e.matches) {
			$isSmall = true;
			$activeTab = 1;
		} else {
			$isSmall = false;
			$activeTab = -1;
		}
	}

	onMount(() => {
		const mql = window.matchMedia("(max-width: 720px)");
		$isSmall = mql.matches;
		$activeTab = ($isSmall ? 1 : -1);

		mql.addEventListener('change', mqHandler);

	});

	$: {
		if (!$renderVis) {
			$renderedPost = {name: "", url: ""};
		}
	}

	function handleAbout(event) {
		aboutVis = true;
	}

	function handleRender() {
		$renderVis = true;
	}

	async function handleShare() {
		if (navigator.share) {
			const blob = await dataToBlob($renderedPost.url);
			let imgfile = new File([blob], $renderedPost.name, {
				type: "image/png"
			});

			let shareData = { files: [imgfile] }

			try {
				await navigator.share(shareData);
			} catch (err) {
				alert("Sharing failed. Use the share button or try right-clicking or long-pressing the image to share.");
			}
		} else {
			alert("Sharing API is not available for your device. Try right-clicking or long-pressing the image to share.");
		}
	}

	function handleSave() {
		const downloader = document.querySelector("#downloader");
		let downlink = document.createElement("a");

		if (downloader.innerHTML) {
    		downloader.innerHTML = null;
    	}

    	downlink.href = $renderedPost.url;
    	downlink.download = $renderedPost.name;

    	downloader.appendChild(downlink);
    	downlink.click();
	}

	function resetScroll() {
	  const settingsPanel = document.querySelector(".settings-wrapper");
	  settingsPanel.scrollTop = 0;
	}

	async function dataToBlob(url) {
		const res = await fetch(url);
		return res.blob();
	}

</script>

<div id="container" class:overlain={aboutVis || $renderVis}>
	<div id="gridbox">
		{#if !$isSmall}

		<section id="settings-drawer">
			<header id="header">
				<h1>Typepost</h1>
				<p class="byline">a simple text post generator for social media</p>
			</header>

			<form id="controls" on:submit|preventDefault>
				{#each panels as panel (panel.id)}
					<div class="panel" id="{panel.label}">
						<svelte:component this={panel.panel} />
					</div>
				{/each}
			</form>

			<Footer on:about={handleAbout} />
		</section>

		{/if}

		<section id="display">
			<Editor />
		</section>

		{#if $isSmall}

		<section id="tab-wrapper">
			<TabGroup tabs={panels} bind:activeTab={$activeTab} on:switch={resetScroll} />
		</section>

		<section id="small-settings">
			<div class="settings-wrapper">
				<form id="controls" on:submit|preventDefault>
					{#each panels as panel (panel.id)}
						<div class="panel {panel.id === $activeTab ? 'active' : ''}" role="tabpanel" id="{panel.label}">
							<svelte:component this={panel.panel} />
						</div>
					{/each}
				</form>

				<Footer on:about={handleAbout} />
			</div>
		</section>

		{/if}
	</div>

	<div id="downloader">

	</div>

	<Modal bind:visible={aboutVis} secondary={false}>
		<div slot="content" class="content">
			<h3>
				About Typepost
			</h3>
			<p>
				<a href="javascript:void(0)" on:click={() => location.reload()}>Typepost</a> version 3.5. &copy; 2024. Made by <a href="https://chuck.aligbe.com" target="_blank">Chuck Aligbe</a>. Typepost is a simple text post builder to create impactful text images for your social media needs. Edit the textboxes, select your colors, and even set a background image for your post. Design to your heart's content. Distributed under the MIT License. All rights reserved. Built with <a href="https://svelte.dev/" target="_blank">Svelte</a> and <a href="https://github.com/bubkoo/html-to-image" target="_blank">html-to-image</a>.
			</p>
		</div>

	</Modal>

	<Modal bind:visible={$renderVis}>
		<div slot="content" class="content">
			{#if $renderedPost.url}
				<img src="{$renderedPost.url}" alt="Rendered Post">
			{:else}
				<div class="loading color-change">
					<span>Rendering...</span>
				</div>
			{/if}

			<p>
				Use the <strong>Download</strong> and <strong>Share</strong> buttons below to save or share your Typepost. You can also right click or long press the image to save, copy, and share your Typepost.
			</p>
		</div>
		<div slot="primary-action" id="downshare">
			<button id="download" disabled={!$renderedPost.url} on:click={handleSave}>
				<span>Download</span>
			</button>

			<button id="share" class="icon secondary" class:hidden={!navigator.share} disabled={!$renderedPost.url} on:click={handleShare}>
				<img src="img/share.svg" alt="">
				<span>Share</span>
			</button>
		</div>
	</Modal>

</div>

<style lang="scss">
	#container {
		width: 100%;
		height: 100%;
		position: relative;

		&.overlain {
			overflow: hidden;
		}
	}

	#gridbox {
		position: relative;
		display: grid;
		height: 100%;
		grid-template-columns: 400px 1fr;
	}

	#settings-drawer {
			position: relative;
	    z-index: 3;
	    height: 100vh;
	    overflow-x: hidden;
	    overflow-y: scroll;
	    background-color: #f0f0f0;

		& > :global(*) {
			margin: 0 1.5rem 1.5rem;
		}
	}

	#header {
		h1 {
			margin-bottom: 0;
		}

		.byline {
			font-size: 0.875rem;
		}
	}

	#display {
	  position: relative;
	  z-index: 1;
	  display: grid;
	  place-items: center;
	  max-height: 100vh;
	  overflow: hidden;
	  background-color: #c9c9cc;
	}

	#tab-wrapper {
	   width: 100%;
	   min-height: 3rem;
	}

	#small-settings {
		position: relative;
		overflow: hidden;
	    padding-top: 0;
		background-color: #f0f0f0;

	    .settings-wrapper {
	    	height: 100%;
	    	padding: 1.25rem 1.25rem 3rem;
	    	overflow-y: scroll;
	    }

	    .panel {
	    	display: none;
	    	height: 100%;
	    }

	    .panel.active {
	    	display: block;
	    }
	}

	:global(div.--color-picker) {
		width: 100%;
	}

	:global(div.--gradient-picker) {
		width: 100%;
	}

	#downshare {
		display: flex;
		gap: 0.5rem;
		flex-basis: 50%;

		button#download {
			flex-basis: 100%;
		}
	}

	/*
	#fontloader {
	  position: relative;
		width: 0;
		height: 0;
		opacity: 0;
	}
	*/

	@media screen and (min-width: 721px) and (max-width: 960px) {
		#gridbox {
			grid-template-columns: 360px 1fr;
		}
	}

	@media screen and (max-width: 720px) {
	  #gridbox {
	    display: grid;
	    grid-template-columns: 1fr;
	    grid-template-rows: min-content min-content 1fr;
	  }

	  #display {
		padding: 0.5rem;
	  }

	  #header {
	    display: none;
	  }
	}
</style>
